import { render } from "./PartnerDellBusiness.vue?vue&type=template&id=39680c06"
import script from "./PartnerDellBusiness.vue?vue&type=script&lang=js"
export * from "./PartnerDellBusiness.vue?vue&type=script&lang=js"

import exportComponent from "/home/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__